module.exports = __webpack_public_path__ + "img/wrong-icon.911e05e3.png";